import { HOME_HANDLE } from 'constants/contentful';
import { getMagazineUrl } from 'modules/magazine/util';

// Only routing fields are needed, including when reading a rich-text target.
interface LinkReference {
  sys: { contentType: { sys: { id: string } } };
  fields?: {
    handle?: string;
    mainCategory?: { fields?: { handle: string } };
    subCategory?: { fields?: { handle: string } };
  };
}

export const generateLink = (reference?: LinkReference): string => {
  // fields is absent when Contentful could not resolve the link
  const handle = reference?.fields?.handle;

  if (!reference || !handle) {
    return '';
  }

  if (reference.sys.contentType.sys.id === 'blogPost') {
    const mainCategory = reference.fields?.mainCategory?.fields;
    const subCategory = reference.fields?.subCategory?.fields;

    if (!mainCategory || !subCategory) {
      return '';
    }

    return getMagazineUrl({ mainCategory, subCategory, blogPost: handle }, false);
  }

  return handle === HOME_HANDLE ? '/' : `/${handle}`;
};
